import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DeviceStatusEnum } from '../../../data/enums/device-status-enum';
import { CommonGlobalService } from '../../../services/common-global.service';
import { LineGraphService } from '../../../services/line-graph.service';
import { DevicePingFilterDto } from '../../SideComponents/status-history/status-history.component';

@Component({
  selector: 'app-avilability-graph',
  templateUrl: './avilability-graph.component.html',
  styleUrls: ['./avilability-graph.component.scss'],
  providers: [MessageService]
})

export class AvilabilityGraphComponent implements OnInit {
  @Input() deviceIP: string;
  @Input() lineId: number;
  @Input() isMonitored: boolean;
  @Input() pairNum: number;

  fromDate: Date = new Date(new Date().setDate(new Date().getDate() - 1));
  toDate: Date = new Date();
  loader: boolean = false;

  allIntervals: any[]=[];
  chart: any = {}
  chartOptions: any;

  tempEmptyArray: any[] = [];
  constructor(private lineGraphService: LineGraphService, private messageService: MessageService,
    private commonGlobalServcie: CommonGlobalService) { }


  ngOnInit(): void {

    //this.isMonitored
    //  ? (this.deviceIP) ? this.GetStatusLogs() : this.loader = false
    //  : this.drawStatusRangeBarChart(this.tempEmptyArray);
    this.commonGlobalServcie.ipAddress = this.deviceIP;
    //if (this.deviceIP) {
    //  this.GetStatusLogs();
    //}
  }
  ngOnChanges() {
    
    this.isMonitored
      ? (this.deviceIP) ? this.GetStatusLogs() : this.loader = false
      : this.drawStatusRangeBarChart(this.tempEmptyArray);
  }
  ///`LineDetails/device-ping-changes-log`
  async GetStatusLogs() { 
    this.loader = true;
    let pair = this.pairNum ? this.pairNum : null;
    let obj: DevicePingFilterDto = { deviceId: 0, deviceIp: this.deviceIP, fromDate: this.fromDate, toDate: this.toDate, pairNumber: pair };
    await this.lineGraphService.getDevicePingChangesLogs(obj).subscribe((res: any[]) => {
      if (res.length > 0) {
        this.allIntervals = res.map((item) => { return { x: this.mapStatus(item.status), y: [new Date(item.from).getTime(), new Date(item.to).getTime()], fillColor: availabilityChartColors.mapStatusColor(item.status)  } })
      }
        this.drawStatusRangeBarChart(this.allIntervals /*tempStatusLogs.reverse()*/);

    }, (error) => {
      this.loader = false;
      this.messageService.add({ severity: 'error', summary: 'Devices Changes Log', detail: 'Could not retrieve ChangesLog now' });
    });
  }

  drawStatusRangeBarChart(logs: any[]) {

    this.destroyChartEvent();
    this.chartOptions = {
      series: [
        {
          data: logs
        }
      ],
      chart: {
        height: 200,
        type: "rangeBar",
        toolbar: {
          show: false ,
        },

      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: 20
        }
      },
      //title: {
      //  text: 'Status Logs (24H)',
      //},
      tooltip: {
        y: {
          title: {

            formatter: function (value1, value2) {
              let starttime = new Date(value2.start);
              let starthours = starttime.getHours().toString(); if (starthours.length == 1) starthours = "0" + starthours;
              let startminutes = starttime.getMinutes().toString(); if (startminutes.length == 1) startminutes = "0" + startminutes;

              let endtime = new Date(value2.end);
              let endhours = endtime.getHours().toString(); if (endhours.length == 1) endhours = "0" + endhours;
              let endminutes = endtime.getMinutes().toString(); if (endminutes.length == 1) endminutes = "0" + endminutes;
         
              let tooltip = 'From ' + starthours + ':' + startminutes + ' To ' + endhours + ':' + endminutes;

              return tooltip;
            }
          }

        }
      },
      xaxis: {
        type: "datetime",
        labels: {
          datetimeUTC: false,
        }
      },
      grid: {
        xaxis: {
          lines: {
            show: true
          }
        }, yaxis: {
          lines: {
            show: true
          }
        },
        row: {
          colors: ["#f3f4f5", "#fff"],
          opacity: 1
        }
      },
      noData: {
        text: 'No Data Found',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
      }
    };

    this.chart = new ApexCharts(document.querySelector("#status-chart"), this.chartOptions);
    this.chart.render();
    this.loader = false;
  }


  mapStatus(status) {
     const key = Object.values(DeviceStatusEnum)[status];
    return key;

  }

 

  destroyChartEvent() {
    if (this.chart instanceof ApexCharts) {
      (<ApexCharts>this.chart).destroy();
    }
  }


}

export class availabilityChartColors {
  static mapStatusColor(status: any): any {
    if (status == 2) status = 0;
    if (status == 0) return '#FF4560';
    if (status == 1) return '#45ff87';
    if (status == 3) return '#bababa';
    if (status == 4) return '#090909';
  }
  
}
